var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9240_993)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8254 37.7794V35.281C55.8254 28.4984 50.327 23 43.5443 23C36.7617 23 31.2633 28.4984 31.2633 35.281V37.7794C28.0703 39.1729 26.0046 42.3238 26 45.8076V56.3343C26.0058 61.1766 29.9298 65.1007 34.7721 65.1065H52.3165C57.1588 65.1007 61.0828 61.1766 61.0887 56.3343V45.8076C61.0841 42.3238 59.0184 39.1729 55.8254 37.7794ZM45.2987 52.8254C45.2987 53.7944 44.5133 54.5798 43.5443 54.5798C42.5754 54.5798 41.7899 53.7944 41.7899 52.8254V49.3165C41.7899 48.3476 42.5754 47.5621 43.5443 47.5621C44.5133 47.5621 45.2987 48.3476 45.2987 49.3165V52.8254ZM52.3165 37.0355H34.7721V35.2811C34.7721 30.4364 38.6995 26.5089 43.5443 26.5089C48.3891 26.5089 52.3165 30.4363 52.3165 35.2811V37.0355Z",
    fill: "#D6D6D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9240_993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockLinkIcon);
export default __webpack_public_path__ + "static/media/unlock-link-icon.00b5494617f00696a7c0ce689f8b6f46.svg";
export { ForwardRef as ReactComponent };